import styled from "styled-components";

const BtnApplyContainer = styled.div`

`;

export default BtnApplyContainer;